import clsx from 'clsx';
import { FunctionComponent } from 'react';
import styles from './GroupItem.module.scss';

interface GroupItemProps {
    label: string;
    className?: string;
}

export const GroupItem: FunctionComponent<GroupItemProps> = props => {
    return (
        <div className={clsx(styles.container, props.className)}>
            <span className={styles.label}>{props.label}</span>
        </div>
    );
};

export default GroupItem;
